import { Box, Group, Paper, ScrollArea } from '@mantine/core';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

import { FarmsDataGrid } from '../../components/farms-data-grid/farms-data-grid';
import FieldsStatusSynthesis from '../../components/fields-status-synthesis/fields-status-synthesis';
import ProductionSynthesis from '../../components/production-synthesis/production-synthesis';
import { StatisticsHeader } from '../../components/statistics-header/statistics-header';
import useAdminStats from '../../data-access/hooks/use-admin-stats/admin-stats';
import { GraphsData } from '../../data-access/types/stats';

import { ErrorPage } from './page.error';
import { PendingPage } from './page.pending';

dayjs.extend(advancedFormat);

export function StatisticsPage() {
  const stats = useAdminStats();

  const graphsData: (GraphsData & {
    crop: string;
  })[] = stats.data
    ? Object.entries(stats.data.graphs).map(
        ([key, values]: [string, GraphsData]) => {
          return {
            crop: key,
            ...values,
          };
        },
      )
    : [];

  return (
    <>
      <Box mb="x2s">
        <StatisticsHeader />
      </Box>
      <ScrollArea>
        <Paper
          mih={360}
          miw={1500}
          my="x2s"
          shadow="sm"
          style={{
            display: 'flex',
          }}
          withBorder
        >
          {/* <Group wrap="nowrap"> */}
          {graphsData.map((graph) => (
            <Group key={graph.crop} mr="md" wrap="nowrap">
              <FieldsStatusSynthesis
                crop={graph.crop}
                data={graph.field_status}
              />
              <ProductionSynthesis crop={graph.crop} data={graph.production} />
            </Group>
          ))}
          {/* </Group> */}
        </Paper>
      </ScrollArea>
      <Box mt="x2s">
        <FarmsDataGrid />
      </Box>
    </>
  );
}

StatisticsPage.Error = ErrorPage;
StatisticsPage.Pending = PendingPage;

export default StatisticsPage;
